<header><ui-header></ui-header></header>
<nav [hidden]="isDashboardLayout"><ui-breadcrumbs></ui-breadcrumbs></nav>
<main #main>
  <router-outlet></router-outlet>
</main>
<footer><ui-footer></ui-footer></footer>
@if (displayTimeoutModal) {
  <ui-modal #userTimeoutModal [id]="'timeoutModal'" [paddedContent]="true" [isVisible]="displayTimeoutModal" [modalTitle]="'Idle Timeout Warning'" [hasCloseButton]="false" [modalSize]=" 'MEDIUM' | modalSizeEnumPipe">
    <div modalContent>
      <p class="aln-center">
        You have been idle for {{IDLE_INTERVAL_IN_SECONDS/60}} minutes.<br />
        You will automatically be logged out in {{secondsLeftToLogout}} seconds.
      </p>
    </div>
  </ui-modal>
}
<ui-modal id="openpage-modal" (closed)="externalLinkService.cancel()" [paddedContent]="true" [hasCloseButton]="true"
  [isVisible]="(externalLinkService.isModalVisible$ | async) ?? false" [modalSize]="'MEDIUM' | modalSizeEnumPipe" modalTitle="Open an external link?">
  <div modalContent class="flex-vrt">
    <p class="aln-center">
      The system is about to open an external page or document in a new tab. Do you wish to continue?
    </p>
    <div class="dis-flex open-page">
      <button uiLibButton [color]="'PRIMARY' | buttonColorEnumPipe" [size]="'MEDIUM' | buttonSizeEnumPipe"
        [shape]="'ROUNDED' | buttonShapeEnumPipe" [style]="'SOLID' | buttonStyleEnumPipe"
        (click)="externalLinkService.confirm()">OK</button>
      <button uiLibButton [color]="'PRIMARY' | buttonColorEnumPipe" [size]="'MEDIUM' | buttonSizeEnumPipe"
        [shape]="'ROUNDED' | buttonShapeEnumPipe" [style]="'SOLID' | buttonStyleEnumPipe"
        (click)="externalLinkService.cancel()">CANCEL</button>
    </div>
  </div>
</ui-modal>
<ui-lib-loader #loader [loaderStyle]="loaderStyle" [loaderSize]="loaderSize"></ui-lib-loader>
<ui-toaster [position]="toasterPosition"></ui-toaster>
